<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input clearable v-model="listQuery.account_name" :placeholder="$t('publicAccount.publicAccountName')" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-input clearable v-model="listQuery.title" :placeholder="$t('publicAccountNews.newsTitle')" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <div class="filter-item">
        <el-date-picker
          v-model="listQuery.publish_time"
          type="datetimerange"
          align="right"
          :start-placeholder="$t('publicAccountNews.publishStartTime')"
          :end-placeholder="$t('publicAccountNews.publishEndTime')"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        {{ $t('table.search') }}
      </el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">
        {{ $t('table.add') }}
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" prop="id" sortable="custom" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccount.publicAccountName')" align="center" min-width="180px">
        <template slot-scope="scope">
          <span>{{ scope.row.account_name }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.newsTitle')" align="center" min-width="250px">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccount.coverPicture')" align="center" width="150px">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="$publicData.imgUrl + scope.row.cover"
            :preview-src-list="[$publicData.imgUrl + scope.row.cover]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.publishTime')" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.publish_time }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.likeNum')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.like_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.collectNum')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.collect_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('publicAccountNews.commentNum')" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{ scope.row.comment_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.status')" align="center" width="100px">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="2"
            @change="statusChange($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.sort')" align="center" width="200px">
        <template slot-scope="scope">
          <el-input-number size="small" v-model="scope.row.sort_index" @change="setSort($event, $event, scope.row)" :min="0"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.actions')" fixed="right" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">
            {{ $t('table.edit') }}
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            {{ $t('table.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <el-dialog :title="textMap" :visible.sync="dialogFormVisible" width="80%">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" :label-width="formLabelWidth" v-loading="dialogFormLoading">
        <el-form-item :label="$t('publicAccount.publicAccount')" prop="biz">
          <el-select v-model="temp.biz" :placeholder="$t('form.pleaseSelect')">
            <el-option
              v-for="item in publicAccounts"
              :key="item.biz"
              :label="item.account_name"
              :value="item.biz">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.title')" prop="title">
          <el-input v-model="temp.title" />
        </el-form-item>
        <el-form-item :label="$t('publicAccount.cover')" prop="cover">
          <image-upload ref="imageUpload" :image-list="imageDefaultList" @imageAdd="imageAdd" @imageRemove="imageRemove"></image-upload>
        </el-form-item>
        <el-form-item :label="$t('publicAccountNews.publishTime')">
          <el-date-picker
            v-model="temp.publish_time"
            type="datetime"
            :placeholder="$t('form.selectTime')"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('publicAccountNews.likeNum')">
          <el-input type="number" min="0" v-model="temp.like_num" />
        </el-form-item>
        <el-form-item :label="$t('publicAccountNews.collectNum')">
          <el-input type="number" min="0" v-model="temp.collect_num" />
        </el-form-item>
        <el-form-item :label="$t('publicAccountNews.commentNum')">
          <el-input type="number" min="0" v-model="temp.comment_num" />
        </el-form-item>
        <el-form-item :label="$t('publicAccountNews.content')" prop="content">
          <tinymce ref="editor" v-model="temp.content" :height="400" v-if="dialogFormVisible"></tinymce>
        </el-form-item>
        <el-form-item :label="$t('table.status')">
          <el-switch
            v-model="temp.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="2">
          </el-switch>
        </el-form-item>
        <el-form-item :label="$t('table.sort')">
          <el-input-number v-model="temp.sort_index" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          {{ $t('table.cancel') }}
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          {{ $t('table.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, fetchPublicAccountNews, createPublicAccountNews, updatePublicAccountNews, delPublicAccountNews, editStatus, editSort } from '@/api/publicAccountNews'
import { fetchAllList } from '@/api/publicAccount'
import waves from '@/directive/waves' // Waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import ImageUpload from '@/components/Upload/image'
import Tinymce from '@/components/Tinymce'

export default {
  name: 'NewsPublicAccount',
  components: { Pagination, ImageUpload, Tinymce },
  directives: { waves },
  data() {
    var validateCover = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('publicAccount.coverRequired')))
      } else {
        callback()
      }
    }
    var validateBiz = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('publicAccount.bizRequired')))
      } else {
        callback()
      }
    }
    var validateTitle = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('publicAccountNews.titleRequired')))
      } else {
        callback()
      }
    }
    var validateContent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('publicAccountNews.contentRequired')))
      } else {
        callback()
      }
    }
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        account_name: undefined,
        id_sort: 'desc',
        publish_time: '',
        title: undefined
      },
      temp: {
        id: undefined,
        title: '',
        cover: '',
        biz: '',
        publish_time: '',
        like_num: 0,
        collect_num: 0,
        comment_num: 0,
        status: 1,
        sort_index: 0,
        content: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      rules: {
        cover: [{ required: true, validator: validateCover, trigger: 'change' }],
        biz: [{ required: true, validator: validateBiz, trigger: 'blur' }],
        title: [{ required: true, validator: validateTitle, trigger: 'blur' }],
        content: [{ required: true, validator: validateContent, trigger: 'blur' }]
      },
      imageDefaultList: '',
      dialogFormLoading: false,
      publicAccounts: [],
      language: this.$store.getters.language
    }
  },
  created() {
    this.getList()
    this.getPublicAccountList()
  },
  computed: {
    formLabelWidth: function() {
      return this.$store.getters.language === 'zh' ? '100px' : '200px'
    },
    textMap: function() {
      return this.dialogStatus === 'update' ? this.$t('form.edit') : this.$t('form.create')
    }
  },
  methods: {
    getPublicAccountList() {
      fetchAllList().then((res) => {
        if (res.code === 20000) {
          this.publicAccounts = res.data.list
        }
      })
    },
    imageAdd(file) {
      this.temp.cover = file.path
    },
    imageRemove(file) {
      this.temp.cover = ''
    },
    setSort(currentValue, oldValue, row) {
      editSort({ id: row.id, sort_index: currentValue }).then((res) => {
        if (res.code === 20000) {
          this.$message.success(this.$t('form.updateSuccess'))
        }
      })
    },
    getList() {
      var params, startTime, endTime
      if (this.listQuery.publish_time !== '' && this.listQuery.publish_time !== null && this.listQuery.publish_time !== undefined) {
        startTime = this.listQuery.publish_time[0]
        endTime = this.listQuery.publish_time[1]
      } else {
        startTime = ''
        endTime = ''
      }
      params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        account_name: this.listQuery.account_name,
        title: this.listQuery.title,
        id_sort: this.listQuery.id_sort,
        start_time: startTime,
        end_time: endTime
      }
      this.listLoading = true
      fetchList(params).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      if (prop === 'id') {
        this.sortByID(order)
      }
    },
    sortByID(order) {
      if (order === 'ascending') {
        this.listQuery.id_sort = 'asc'
      } else {
        this.listQuery.id_sort = 'desc'
      }
      this.handleFilter()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        title: '',
        cover: '',
        biz: '',
        publish_time: '',
        like_num: 0,
        collect_num: 0,
        comment_num: 0,
        status: 1,
        sort_index: 0,
        content: ''
      }
      this.imageDefaultList = ''
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.$refs['imageUpload'].clearFileList()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createPublicAccountNews(this.temp).then((res) => {
            if (res.code === 20000) {
              this.dialogFormVisible = false
              this.$message.success(this.$t('form.createSuccess'))
              this.handleFilter()
            }
          })
        }
      })
    },
    handleUpdate(row) {
      this.dialogFormLoading = true
      this.resetTemp()
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.$refs['imageUpload'].clearFileList()
      })
      fetchPublicAccountNews(row.id).then((res) => {
        var path = res.data.detail.cover
        this.temp = {
          id: res.data.detail.id,
          title: res.data.detail.title,
          cover: path,
          biz: res.data.detail.biz,
          publish_time: res.data.detail.publish_time,
          like_num: res.data.detail.like_num,
          collect_num: res.data.detail.collect_num,
          comment_num: res.data.detail.comment_num,
          status: res.data.detail.status,
          sort_index: res.data.detail.sort_index,
          content: res.data.detail.content
        }
        this.imageDefaultList = JSON.stringify([
          {
            name: path.substr(path.lastIndexOf('/') + 1),
            url: this.$publicData.imgUrl + path,
            path: path
          }
        ])
        this.dialogFormLoading = false
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          updatePublicAccountNews(this.temp).then(() => {
            this.dialogFormVisible = false
            this.$message.success(this.$t('form.updateSuccess'))
            this.handleFilter()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPublicAccountNews({ id: row.id }).then((res) => {
          if (res.code === 20000) {
            this.$message.success(this.$t('form.delSuccess'))
            this.handleFilter()
          }
        })
      }).catch(() => {
      })
    },
    statusChange(val, row) {
      editStatus({ id: row.id, status: val }).then((res) => {
        if (res.code === 20000) {
          this.$message.success(this.$t('form.updateSuccess'))
        }
      })
    }
  }
}
</script>
